/**
 * FNV-1a 32-bit hash. Deterministic, fast, ASCII-friendly.
 *
 * Used by the bucketing primitives in this directory; must produce identical
 * output in CloudFront Functions (`cloudfront-js-2.0`) and the SSR lambda
 * runtime. Math.imul is supported in both.
 *
 * NOT cryptographic — bucketing distribution only.
 */
/* eslint-disable no-bitwise -- FNV-1a is bitwise by definition; reference vectors in fnv1a32.test.ts depend on XOR + `>>> 0` uint32 conversion (Math.trunc is NOT equivalent for negative-bit-pattern results). */
export function fnv1a32(input: string): number {
  let hash = 0x811c9dc5; // FNV offset basis (32-bit)
  for (let i = 0; i < input.length; i++) {
    hash ^= input.codePointAt(i) ?? 0;
    hash = Math.imul(hash, 0x01000193); // FNV prime
  }
  return hash >>> 0;
}
